import { Permiso } from "@/shared/types/permiso";

type PermisoListEntry = {
    name: string,
    value: string
}

type PermisoListCategory = {
    name: string,
    content: (PermisoListCategory | PermisoListEntry)[]
};

export const permisosConfig: (PermisoListCategory | PermisoListEntry)[] = [
    {
        name: "Auxiliares", content: [
            {
                name: "Manejo de Rubros", content: [
                    { name: "Lectura de Rubros", value: Permiso.ReadRubros },
                    { name: "Escritura de Rubros", value: Permiso.WriteRubros },
                ]
            },
            {
                name: "Manejo de Proveedores", content: [
                    { name: "Lectura de Proveedores", value: Permiso.ReadProveedores },
                    { name: "Escritura de Proveedores", value: Permiso.WriteProveedores },
                ]
            },
            {
                name: "Manejo de Clientes", content: [
                    { name: "Lectura de Clientes", value: Permiso.ReadClientes },
                    { name: "Escritura de Clientes", value: Permiso.WriteClientes },
                ]
            },
            {
                name: "Manejo de Vendedores", content: [
                    { name: "Lectura de Vendedores", value: Permiso.ReadVendedores },
                    { name: "Escritura de Vendedores", value: Permiso.WriteVendedores },
                ]
            },
            {
                name: "Manejo de Cuenta Corrientes", content: [
                    { name: "Lectura de Cuenta Corrientes", value: Permiso.ReadCuentaCorrientes },
                    { name: "Escritura de Cuenta Corrientes", value: Permiso.WriteCuentaCorrientes }
                ]
            }
        ]
    },
    {
        name: "Inventario", content: [
            {
                name: "Manejo de Artículos", content: [
                    { name: "Lectura de Artículos", value: Permiso.ReadArticulos },
                    { name: "Lectura de Historial", value: Permiso.ReadArticuloHistorial },
                    { name: "Escritura de Artículos", value: Permiso.WriteArticulos },
                    { name: "Edición de Cantidad de Artículos", value: Permiso.WriteArticulosCantidad },
                ]
            },
            {
                name: "Manejo de Transferencias", content: [
                    { name: "Lectura de Transferencias", value: Permiso.ReadArticuloTransferencias },
                    { name: "Escritura de Transferencias", value: Permiso.WriteArticuloTransferencias },
                ]
            },
            {
                name: "Salida de Artículos", content: [
                    { name: "Lectura de Salida de Artículos", value: Permiso.ReadArticuloMovimientos },
                    { name: "Escritura de Salida de Artículos", value: Permiso.WriteArticuloMovimientos },
                ]
            },
            {
                name: "Manejo de Compras", content: [
                    { name: "Lectura de Compras", value: Permiso.ReadCompras },
                    { name: "Escritura de Compras", value: Permiso.WriteCompras },
                ]
            },
            {
                name: "Manejo de Ventas", content: [
                    { name: "Lectura de Ventas", value: Permiso.ReadVentas },
                    { name: "Escritura de Ventas", value: Permiso.WriteVentas },
                    { name: "Permitir Stock Negativo", value: Permiso.AllowNegativeStock }
                ]
            },
        ]
    },
    {
        name: "Caja", content: [
            {
                name: "Manejo de Cajas", content: [
                    { name: "Lectura de Cajas", value: Permiso.ReadCajas },
                    { name: "Escritura de Cajas", value: Permiso.WriteCajas },
                ]
            },
            {
                name: "Manejo de Movimiento de Caja", content: [
                    { name: "Lectura de Movimiento de Caja", value: Permiso.ReadMovimientoCajas },
                    { name: "Escritura de Movimiento de Caja", value: Permiso.WriteMovimientoCajas },
                    { name: "Historial de Arqueo de la Caja", value: Permiso.HistorialAperturaCajaActual },
                    { name: "Lectura de Ventas No Pagadas", value: Permiso.ReadUnpaidVentas },
                    { name: "Pago de Ventas", value: Permiso.PagarVenta }
                ]
            },
            {
                name: "Administración de Cajas", content: [
                    { name: "Apertura/Cierre de Caja", value: Permiso.AperturaCierreCajas },
                    { name: "Historial de Arqueo de Cajas", value: Permiso.HistorialAperturaCajas },
                    { name: "Asignación de Cajas", value: Permiso.AsignarCajas }
                ]
            }
        ]
    },
    {
        name: "Reportes", content: [
            { name: "Reportes de Ventas", value: Permiso.ReporteVentas },
            { name: "Reportes de Artículos", value: Permiso.ReporteVentaItems }
        ]
    },
    {
        name: "Administración", content: [
            { name: "Manejo de Usuarios", value: Permiso.ManageUsuarios },
            { name: "Manejo de Permisos", value: Permiso.ManagePermisos },
            { name: "Auditoria", value: Permiso.Auditoria },
            { name: "Configuracion", value: Permiso.ManageConfiguracion },
            { name: "Monetización", value: Permiso.ManageMonetizacion }
        ]
    },
    {
        name: "Facturación Electrónica", content: [
            { name: "Lectura de Documentos Electrónicos", value: Permiso.ReadDocumentosElectronicos },
            { name: "Escritura de Documentos Electrónicos", value: Permiso.WriteDocumentosElectronicos },
            { name: "Envío a SIFEN", value: Permiso.SendDocumentosElectronicos },
            { name: "Eliminación de Documentos Electrónicos", value: Permiso.DeleteDocumentosElectronicos },
            { name: "Reservar Numeración", value: Permiso.ReservarDocumentosElectronicos },
            { name: "Configuración de Facturación Electrónica", value: Permiso.ManageConfiguracionFacturacionElectronica },
            { name: "Reenvío de Emails", value: Permiso.SendEmails }
        ]
    },
    {
        name: "Actividades Comerciales", content: [
            { name: "Lectura", value: Permiso.ReadActividadesComerciales },
            { name: "Escritura", value: Permiso.WriteActividadesComerciales },
        ]
    },

] as const;
